import useLocalStorage from "@rehooks/local-storage";

import AnnouncementTile, { AnnouncementTileBackgroundType } from "components/AnnouncementTile";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import TileContent from "ds/components/Tile/Content";
import Typography from "ds/components/Typography";

import { isExternalLink } from "./helpers";
import styles from "./styles.module.css";
import { AnnouncementProps } from "./types";

const DashboardOverviewColumnAnnouncement = ({
  bannerId,
  content,
  dismissible = true,
  preTitle,
  primaryLink,
  primaryLinkText,
  secondaryLink,
  secondaryLinkText,
  title,
}: AnnouncementProps) => {
  const [closedOnboardingAnnouncements, setClosedOnboardingAnnouncements] = useLocalStorage<
    string[]
  >("dashboardWidgetAnnouncementClosed");

  if (closedOnboardingAnnouncements?.includes(bannerId)) {
    return null;
  }

  const isExternalPrimaryLink = isExternalLink(primaryLink ?? "");
  const isExternalSecondaryLink = isExternalLink(secondaryLink ?? "");

  return (
    <AnnouncementTile
      backgroundType={AnnouncementTileBackgroundType.Clouds}
      onDismiss={
        dismissible
          ? () =>
              setClosedOnboardingAnnouncements(
                closedOnboardingAnnouncements
                  ? [...closedOnboardingAnnouncements, bannerId]
                  : [bannerId]
              )
          : undefined
      }
    >
      <TileContent direction="column" gap="large">
        <Box direction="column">
          {preTitle && (
            <Typography className={styles.announcementGreyColor} tag="p" variant="p-t7">
              {preTitle}
            </Typography>
          )}
          <Typography className={styles.announcementLightContent} tag="p" variant="p-t4">
            {title}
          </Typography>
        </Box>

        <Typography className={styles.announcementLightContent} tag="p" variant="p-body3">
          {content}
        </Typography>
        <Box direction="row" gap="medium" fullWidth>
          {primaryLink && (
            <LinkButton
              className={styles.linkButton}
              variant="primary"
              to={!isExternalPrimaryLink ? primaryLink : undefined}
              href={isExternalPrimaryLink ? primaryLink : undefined}
              target={isExternalPrimaryLink ? "_blank" : undefined}
              rel={isExternalPrimaryLink ? "noopener noreferrer" : undefined}
            >
              {primaryLinkText ?? ""}
            </LinkButton>
          )}
          {secondaryLink && (
            <LinkButton
              className={styles.linkButton}
              variant="secondary"
              to={!isExternalSecondaryLink ? secondaryLink : undefined}
              href={isExternalSecondaryLink ? secondaryLink : undefined}
              target={isExternalSecondaryLink ? "_blank" : undefined}
              rel={isExternalSecondaryLink ? "noopener noreferrer" : undefined}
            >
              {secondaryLinkText ?? ""}
            </LinkButton>
          )}
        </Box>
      </TileContent>
    </AnnouncementTile>
  );
};

export default DashboardOverviewColumnAnnouncement;
